import axios from "axios";
import React from "react";
import AvatarEditor from "react-avatar-editor";
import LoadingIcon from "../../../Assets/Images/ButtonLoadingIcon.svg";
import { Config } from "../../../Config";

class ProfileImageUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      AlreadyHasImage: false,
      IsUploading: false,
      AvatarURL: "",
      ImageIsChanged: false,
      ChangesMade: false,
      AvatarDeleted: false,
    };
  }
  componentDidMount() {
    this.checkPrevImage();
  }
  translateText(LabelId) {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = this.props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  }
  checkPrevImage() {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/profile-picture",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.imageUrl.length > 0) {
          this.setState({
            AlreadyHasImage: true,
            AvatarURL: Res.data.imageUrl,
          });
        }
      })
      .catch((Err) => {
        console.log(Err);
        this.setState({
          HeaderURL: this.props.Image,
          ChangesMade: true,
          AlreadyHasImage: false,
        });
      });
  }
  onClickSave = () => {
    if (this.editor) {
      if (this.state.AvatarDeleted) {
        this.requestDeleteAvatar();
      } else {
        const canvasScaled = this.editor
          .getImageScaledToCanvas()
          .toDataURL("image/jpeg")
          .split(";base64,")[1];

        const canvasScaledBase64 = this.editor
          .getImageScaledToCanvas()
          .toDataURL("image/jpeg");
        window.localStorage.setItem("UploadedImage", canvasScaledBase64);
        if (this.state.AlreadyHasImage === true) {
          this.requestReplaceImage(canvasScaled);
        } else {
          this.requestUploadImage(canvasScaled);
        }
      }
    }
  };
  requestReplaceImage = (Image) => {
    let Data = new FormData();
    this.setState({ IsUploading: true });
    Data.append("type", "PROFILE");
    Data.append("file", Image);
    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/profile-picture",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        this.props.Close();
        this.props.FetchImage();
        this.setState({ IsUploading: false });
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  requestUploadImage(Image) {
    this.setState({ IsUploading: true });
    let Data = new FormData();
    Data.append("type", "PROFILE");
    Data.append("file", Image);
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/profile-picture",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        this.props.Close();
        this.props.FetchImage();
        this.setState({ IsUploading: false });
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  }
  handleChange() {
    this.setState({
      ImageIsChanged: true,
      AvatarDeleted: false,
    });
    this.props.ChangeImage();
  }
  handleDeleteImage() {
    this.setState({
      ChangesMade: true,
      AvatarDeleted: true,
      ImageIsChanged: true,
      AvatarURL: "",
    });
    this.props.RemoveImage();
  }
  requestDeleteAvatar() {
    let Data = new FormData();
    Data.append("type", "PROFILE");
    let Req = {
      method: "DELETE",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/profile-picture",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "form-data",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        this.props.Close();
        this.props.FetchImage();
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.data.key === "not_found_error") {
          this.props.Close();
        }
      });
  }

  handleClose() {
    this.setState(
      {
        AlreadyHasImage: false,
        IsUploading: false,
        AvatarURL: "",
        ImageIsChanged: false,
        ChangesMade: false,
        AvatarDeleted: false,
      },
      () => {
        this.props.Close();
      }
    );
  }

  setEditorRef = (editor) => (this.editor = editor);
  render() {
    return (
      <div className="image-uploader-wrapper-large">
        <div className="header-image-area avatar-area">
          <section className="image-uploader-head">
            <h1>{this.translateText("profile_photo")}</h1>
            <i
              className="feather-x"
              id="close-avatar-upload-menu"
              onClick={() => this.props.Close()}
            ></i>
          </section>
          <div className="canvas-wrapper avatar-canvas">
            <span
              className="remove is-mobile"
              onClick={() => this.handleDeleteImage()}
            >
              <i className="feather-trash-2"></i>
            </span>
            <AvatarEditor
              image={
                this.props.Image === undefined || this.props.Image === ""
                  ? this.state.AvatarURL
                  : this.props.Image
              }
              width={window.innerWidth > 450 ? 287 : 242}
              height={window.innerWidth > 450 ? 287 : 242}
              color={[71, 79, 89, 0.6]} // RGBA
              border={[0, 0]}
              scale={1}
              rotate={0}
              borderRadius={500}
              ref={this.setEditorRef}
            />

            <p className="hint-text avatar-hint">
              {this.translateText("image_uploader_drag_text")}
            </p>
          </div>
          <section className="cropper-options avatar-options">
            <span
              className="remove is-desktop"
              onClick={() => this.handleDeleteImage()}
            >
              {this.translateText("remove_photo")}
            </span>

            <span className="change" onClick={() => this.handleChange()}>
              {this.translateText("change_photo")}
            </span>
            {this.state.IsUploading ? (
              <span className="apply">
                <img alt="" src={LoadingIcon} />
              </span>
            ) : (
              <span
                className="apply"
                id="apply-profile-btn"
                onClick={() => this.onClickSave()}
              >
                {this.translateText("apply")}
              </span>
            )}
          </section>
        </div>
      </div>
    );
  }
}
export default ProfileImageUploader;
